import type { Plan } from '../interfaces/Plan';
import { isProductionEnvironment } from '../utils/authorization/roles';

export const FREE_PLAN: Plan = {
	id: 'FREE',
	legacy: false,
	integrations: 2,
	extensions: 2,
	viewers: 20,
	editors: 1,
	title: 'Free',
	price: 0,
	annual: {
		price: 0,
		id: 'free',
	},
	monthly: {
		price: 0,
		id: 'free',
	},

	all_plans: ['free'],
};

// @ts-expect-error TS(2741): Property 'price' is missing in type '{ id: string;... Remove this comment to see the full error message
export const CI_PLAN: Plan = {
	id: 'CI',
	legacy: true,
	integrations: 2,
	extensions: 2,
	viewers: 2,
	editors: 2,
	title: 'CI',
	annual: {
		price: 40,
		id: 'ci',
	},
	monthly: {
		price: 50,
		id: 'ci',
	},

	all_plans: ['ci'],
};

// @ts-expect-error TS(2741): Property 'price' is missing in type '{ id: string;... Remove this comment to see the full error message
export const STARTER_PLAN: Plan = {
	id: 'STARTER',
	legacy: true,
	integrations: 1000,
	extensions: 2,
	viewers: 10000,
	editors: 15,
	title: 'Starter',
	annual: {
		price: 40,
		id: isProductionEnvironment()
			? 'price_1Jrn0eK6Kr02pHOonQNAAq7c'
			: 'price_1JrlOVK6Kr02pHOoC3SZ5gKi',
	},
	monthly: {
		price: 50,
		id: isProductionEnvironment()
			? 'price_1Jrn00K6Kr02pHOoJGce8MFx'
			: 'price_1JrlOBK6Kr02pHOoc0XIrPBl',
	},

	all_plans: [
		'starter',
		'price_1JrlOBK6Kr02pHOoc0XIrPBl',
		'price_1JrlOVK6Kr02pHOoC3SZ5gKi',
		'price_1JdxykK6Kr02pHOoiPGfLzwS',
		'price_1JdxwYK6Kr02pHOoXRX4wqKY',
		'price_1JUBxgK6Kr02pHOoWyNO5NHE',
		'price_1JUBxfK6Kr02pHOo925o6m9Y',
		'price_1IQ20rK6Kr02pHOoVRhn7w4j',
		'price_1IQ20rK6Kr02pHOoVRhn7w4j',
		'price_1JeBJvK6Kr02pHOo1wdpbw31',
		'price_1JeBJaK6Kr02pHOoPyXU0jiP',
		'price_1Je88TK6Kr02pHOooj4i1NvD',
		'price_1IQBvsK6Kr02pHOonWDrNL7w',
		'price_1Jrn00K6Kr02pHOoJGce8MFx',
		'price_1Jrn0eK6Kr02pHOonQNAAq7c',
		'price_1JNJDXK6Kr02pHOoumqFJYNr',
	],
};

export const GROWTH_PLAN: Plan = {
	id: 'GROWTH',
	legacy: true,
	integrations: 3,
	extensions: 2,
	viewers: 10000,
	editors: 1000,
	title: 'Growth',
	price: 40,
	annual: {
		price: 40,
		id: isProductionEnvironment()
			? 'price_1KdcgdK6Kr02pHOoZPWBAKPf'
			: 'price_1KdcruK6Kr02pHOoDkzcHQhc',
	},
	monthly: {
		price: 50,
		id: isProductionEnvironment()
			? 'price_1KdcgdK6Kr02pHOoZPWBAKPf'
			: 'price_1KdcruK6Kr02pHOoDkzcHQhc',
	},

	all_plans: [
		'growth',
		'price_1KdcgdK6Kr02pHOoZPWBAKPf',
		'price_1KdcruK6Kr02pHOoDkzcHQhc',
		'price_1NsVfGK6Kr02pHOoG6lVMUOo',
		'price_1NsVJeK6Kr02pHOo1nkbE39Q',
		'price_1NsVHeK6Kr02pHOoUROTJb9Q',
	],
};

export const BUSINESS_PLAN: Plan = {
	id: 'BUSINESS',
	legacy: true,
	integrations: 4,
	extensions: 2,
	viewers: 10000,
	editors: 10000,
	title: 'Business',
	price: 10000,
	annual: {
		price: 10000,
		id: isProductionEnvironment()
			? 'price_1KdchZK6Kr02pHOozncYeGZ6'
			: 'price_1KdcsAK6Kr02pHOoYieLyzi6',
	},
	monthly: {
		price: 10000,
		id: isProductionEnvironment()
			? 'price_1KdchZK6Kr02pHOozncYeGZ6'
			: 'price_1KdcsAK6Kr02pHOoYieLyzi6',
	},

	all_plans: [
		'business',
		'price_1KdchZK6Kr02pHOozncYeGZ6',
		'price_1KdcsAK6Kr02pHOoYieLyzi6',
	],
};

// @ts-expect-error TS(2741): Property 'price' is missing in type '{ id: string;... Remove this comment to see the full error message
export const PREMIUM_PLAN: Plan = {
	id: 'PREMIUM',
	legacy: true,
	integrations: 1000,
	extensions: 2,
	viewers: 10000,
	editors: 1000,
	title: 'Premium',
	annual: {
		price: 79,
		id: isProductionEnvironment()
			? 'price_1JeBHiK6Kr02pHOojtuWTW5h'
			: 'price_1Jdy1hK6Kr02pHOoEkxGJMT5',
	},
	monthly: {
		price: 99,
		id: isProductionEnvironment()
			? 'price_1JeBH4K6Kr02pHOoE9BN3Qjt'
			: 'price_1Jdy1FK6Kr02pHOoAxZWLGwh',
	},

	all_plans: [
		'premium',
		'price_1Jdy1hK6Kr02pHOoEkxGJMT5',
		'price_1Jdy1FK6Kr02pHOoAxZWLGwh',
		'price_1JUC06K6Kr02pHOoMP7duDgh',
		'price_1JUC06K6Kr02pHOo6FSX7UCO',
		'price_1JeBHiK6Kr02pHOojtuWTW5h',
		'price_1JeBH4K6Kr02pHOoE9BN3Qjt',
	],
};

const oldPlans: Plan[] = [
	FREE_PLAN,
	STARTER_PLAN,
	GROWTH_PLAN,
	BUSINESS_PLAN,
	PREMIUM_PLAN,
];

// The new plans. These are the ones currently advertised on the website.
// We should slowly deprecate (remove) the old plans as customers cycle off of them.

export const BASIC_PLAN: Plan = {
	id: 'BASIC',
	legacy: false,
	integrations: 4,
	extensions: 2,
	viewers: 10000,
	editors: 1000,
	title: 'Basic',
	price: 40,
	annual: {
		price: 40,
		id: isProductionEnvironment()
			? 'price_1Or0NVK6Kr02pHOolNvmFdtP'
			: 'price_1Or0pcK6Kr02pHOoaJStPPPx',
	},
	monthly: {
		price: 50,
		id: isProductionEnvironment()
			? 'price_1Or0NVK6Kr02pHOolNvmFdtP'
			: 'price_1Or0pcK6Kr02pHOoaJStPPPx',
	},

	all_plans: [
		'basic',
		'price_1Or0pcK6Kr02pHOoaJStPPPx',
		'price_1Or0NVK6Kr02pHOolNvmFdtP',
	],
};

export const CORE_PLAN: Plan = {
	id: 'CORE',
	legacy: true,
	integrations: 10000,
	extensions: 2,
	viewers: 10000,
	editors: 10000,
	title: 'Core',
	price: 10000,
	annual: {
		price: 10000,
		id: isProductionEnvironment()
			? 'price_1Or0NOK6Kr02pHOoBcHzjorG'
			: 'price_1Or0pLK6Kr02pHOoa7PHwbE5',
	},
	monthly: {
		price: 10000,
		id: isProductionEnvironment()
			? 'price_1Or0NOK6Kr02pHOoBcHzjorG'
			: 'price_1Or0pLK6Kr02pHOoa7PHwbE5',
	},

	all_plans: [
		'core',
		'price_1Or0NOK6Kr02pHOoBcHzjorG',
		'price_1Or0pLK6Kr02pHOoa7PHwbE5',
	],
};

export const ENTERPRISE_PLAN: Plan = {
	id: 'ENTERPRISE',
	icon: 'workspace',
	legacy: false,
	integrations: 10000,
	extensions: 10000,
	viewers: 10000,
	guests: 10000,
	editors: 10000,
	title: 'Enterprise',
	price: 10000,
	annual: {
		price: 999,
		id: isProductionEnvironment()
			? 'price_1IQBvkK6Kr02pHOoN4jWIU5o'
			: 'price_1IQ21ZK6Kr02pHOoxeZq5beF',
	},
	monthly: {
		price: 1299,
		id: isProductionEnvironment()
			? 'price_1IQBvkK6Kr02pHOoCwBlm0xf'
			: 'price_1IQ21ZK6Kr02pHOoVW5gcxCc',
	},

	all_plans: [
		'enterprise',
		'price_1IQ21ZK6Kr02pHOoxeZq5beF',
		'price_1IQ21ZK6Kr02pHOoVW5gcxCc',
		'price_1JRhqVK6Kr02pHOowv4MFhNi',
		'price_1KfvoNK6Kr02pHOoUokGJlp7',
		'price_1KfvnyK6Kr02pHOo9HvLrX8w',
		'price_1KHHHmK6Kr02pHOoTw6B0Zs3',
		'price_1KJ1RgK6Kr02pHOogFyV7Gnq',
		'price_1KCTnJK6Kr02pHOofr2L3zZi',
		'price_1KCRHrK6Kr02pHOovGJ3Dl2e',
		'price_1K9vnWK6Kr02pHOo4bL0J6Gd',
		'price_1JZdq5K6Kr02pHOoZYyGdcrI',
		'price_1IQBvkK6Kr02pHOoCwBlm0xf',
		'price_1JNJEcK6Kr02pHOoZoyhIZb3',
		'price_1KQwFbK6Kr02pHOoVIUM2RlZ',
		'price_1J1DqGK6Kr02pHOo8FUvB2JA',
		'price_1IQBvkK6Kr02pHOoN4jWIU5o',
	],
};

export const TRIAL_PLAN: Plan = {
	id: 'TRIAL',
	legacy: false,
	integrations: 10000,
	extensions: 10000,
	viewers: 10000,
	guests: 10000,
	editors: 10000,
	title: 'Trial',
	price: 10000,
	annual: {
		price: 999,
		id: 'trial',
	},
	monthly: {
		price: 1299,
		id: 'trial',
	},

	all_plans: ['trial'],
};

export const workspacePlans: Plan[] = [
	...oldPlans,
	CI_PLAN,
	BASIC_PLAN,
	CORE_PLAN,
	ENTERPRISE_PLAN,
];
